import { jwtDecode } from "jwt-decode";

export const getPayloadJwt = (token: string) => {
  try {
    const decoded = jwtDecode(token);
    return decoded as any;
  } catch (e) {
    return null;
  }
};

export const extractSubdomainFromToken = (token: string): string => {
  const domain = getPayloadJwt(token)?.domain;
  if (domain !== "cms") {
    return "app";
  }
  return domain;
};
